// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetTextContentPagedListRequestViewModel from '../../viewModel/request/TextContents/GetTextContentPagedListRequestViewModel';
import DownloadTextContentReportRequestViewModel from '../../viewModel/request/TextContents/DownloadTextContentReportRequestViewModel';
import TextContentResourceViewModel from '../../viewModel/resource/TextContentResourceViewModel';
import TextContentTranslationResourcePagingResultViewModel from '../../viewModel/resource/TextContentTranslationResourcePagingResultViewModel';
import Int64LookupResourceListResultViewModel from '../../viewModel/resource/Int64LookupResourceListResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getTextContentById(id: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-text-content-by-id'] ?? 'core/textContents/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new TextContentResourceViewModel().fromDTO(dto);
  },
  /**  */
  async updateTextContent(id: number, model: TextContentResourceViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-text-content'] ?? 'core/textContents/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.put<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const dto = response.data.result;
    return new TextContentResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getTextContentPagedList(request: GetTextContentPagedListRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-text-content-paged-list'] ?? 'core/textContents';
    const response = await service.get<any>(endpointPath, {
      query: {
        scope: requestDTO.scope,
        language: requestDTO.language,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new TextContentTranslationResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async getScopeLookup(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-scope-lookup'] ?? 'core/textContents/scopes/lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new Int64LookupResourceListResultViewModel().fromDTO(dto);
  },
  /**  */
  async downloadTextContentReport(request: DownloadTextContentReportRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-download-text-content-report'] ?? 'core/textContents/report';
    const response = await service.post<any>(endpointPath, {
      responseType: 'blob',
      query: {
        scope: requestDTO.scope,
        language: requestDTO.language,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return new Blob([result], { type: 'application/octet-stream' });
  },
});
